import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit'
import {
  closeInviteGuestDrawer,
  closeMapDescriptionDrawer,
  closeMapFilterDrawer,
  closeMapRemixDrawer,
  closeMapShareDrawer,
  closeSearch,
  closeTable,
  openMapLegend
} from '.'
import { LAYER_TYPES } from '../layerType'
import { MARKER_TYPES } from '../marker'
import { store } from '../store'

const uiListener = createListenerMiddleware()

uiListener.startListening({
  matcher: isAnyOf(
    closeSearch,
    closeMapFilterDrawer,
    closeMapDescriptionDrawer,
    closeMapShareDrawer,
    closeTable,
    closeInviteGuestDrawer,
    closeMapRemixDrawer
  ),
  effect: () => {
    reopenMapLegendIf()
  }
})

export const reopenMapLegendIf = () => {
  const layerType = store.getState().layerType?.layerType
  const markerType = store.getState().marker?.type

  if (layerType === LAYER_TYPES.BOUNDARIES) {
    store.dispatch(openMapLegend())
    return
  }

  if (layerType === LAYER_TYPES.HEXAGON) {
    store.dispatch(openMapLegend())
    return
  }

  if (
    layerType === LAYER_TYPES.MARKER &&
    markerType === MARKER_TYPES.CATEGORIES
  ) {
    store.dispatch(openMapLegend())
    return
  }
}

export { uiListener }
